// Library Imports
import { configureStore, combineReducers } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";

// Local Imports
import currentUserSlice from "@/redux/features/CurrentUser/currentUserSlice";
import mediaKitSlice from "@/redux/features/MediaKit/mediakitSlice";
import instagramDataSlice from "@/redux/features/instagramData/instagramDataSlice";
import tiktokSignupSlice from "@/redux/features/tiktokSignup/tiktokSignupSlice";
import manageKitSlice from "@/redux/features/manageMediaKit/manageKitSlice";
import countriesAndStates from "@/redux/features/getCountriesStates/getStatCountriesStatesSlice";
import dashboardProfile from "@/redux/features/dashboardProfile/dashboardProfileSlice";
import paymentSlice from "@/redux/features/payment/paymentSlice";
import collabCenterSlice from "@/redux/features/collabCenter/collabCenterSlice";
import connectionSlice from "@/redux/features/InternetConnect/InternetConnectSlice";
import selectedContentSlice from "@/redux/features/selectedContent/selectedContentSlice";
import collabRatingSlice from "@/redux/features/collabRating/collabRatingSlice";
import generateMediakitSlice from "@/redux/features/generateMediaKit/generateMediakitSlice";
import uiSlice from "@/redux/features/ui/uiSlice";
import adminDashboardSlice from "@/redux/features/adminDashboard/adminDashboardSlice";
import adminUsersSlice from "@/redux/features/adminUsers/adminUsersSlice";

// Define the persist configuration
const persistConfig = {
  key: "root",
  storage,
  whitelist: ["currentUser", "countriesAndStates"],
};

// Combine your reducers
const rootReducer = combineReducers({
  currentUser: currentUserSlice,
  mediaKit: mediaKitSlice,
  instagramData: instagramDataSlice,
  tiktokSignup: tiktokSignupSlice,
  collabCenter: collabCenterSlice,
  manageMediaKit: manageKitSlice,
  countriesAndStates: countriesAndStates,
  dashboardProfile: dashboardProfile,
  payment: paymentSlice,
  connection: connectionSlice,
  selectedContent: selectedContentSlice,
  collabRating: collabRatingSlice,
  generateMediaKit: generateMediakitSlice,
  ui: uiSlice,
  adminDashboard: adminDashboardSlice,
  adminUsers: adminUsersSlice,
});

// Create a persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure the store with the persisted reducer
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore redux-persist actions
        ignoredActions: [
          'persist/PERSIST',
          'persist/REHYDRATE',
          'persist/PURGE',
          'persist/REGISTER',
          'persist/FLUSH',
          'persist/PAUSE',
          'persist/RESUME',
        ],
        // Ignore file uploads (FormData is not serializable)
        ignoredActionPaths: ['meta.arg.file', 'meta.arg.onProgress'],
        // Ignore non-serializable values in state (file uploads, etc.)
        ignoredPaths: ['mediaKit.mediaKitStates.intro.file'],
      },
    }),
  devTools: import.meta.env.NODE_ENV !== "production",
});

// Create a persistor
export const persistor = persistStore(store);
